

const ContentHeader = ({ title }: { title: string }) => {
  return (
    <section className="content-header">
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <h1>{title}</h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentHeader;
